<template>
  <div class='loading-page'>
    <div class='loading-page_text'>
      We're calculating your target
    </div>
    <div class='lt-loading-animation'>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import { mapFields } from "vuex-map-fields";

export default {
  computed: {
    ...mapFields([
      'ui.showForeground',
      'ui.hasSceneAnimations',
    ]),
    loadingDuration () {
      const seconds = this.hasSceneAnimations ? 3 : 10;
      return seconds * 1000;
    },
  },
  created: function () {
    this.showForeground = false;
    setTimeout(() => this.finishLoading(), this.loadingDuration);
  },
  methods: {
    ...mapMutations([
      'goToNextPage',
    ]),
    finishLoading () {
      this.showForeground = true;
      this.goToNextPage();
    },
  },
};
</script>
